// extracted by mini-css-extract-plugin
module.exports = {"hireProcessImage":"HireProcess_hireProcessImage__LoX9R"};